import { faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons/faLocationDot';
import { faPhone } from '@fortawesome/pro-light-svg-icons/faPhone';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Client from '@spike/client-model';
import { formatPhoneNumber } from '@spike/phone-utils';
import clsx from 'clsx';
import { useMarketplace } from 'hooks';
import { FunctionComponent } from 'react';
import ExpandableSection from './ExpandableSection';
import InfoLine from './InfoLine';
import Tags from './Tags';
import MembershipIcon from './Memberships/MembershipIcon';

export interface PetParentProps {
    client: Client;
    initExpanded?: boolean;
    disableExpandable?: boolean;
    matchMemebrships?: boolean;
    className?: string;
    onShowClient?: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        nameContainer: {
            display: 'flex',
            alignItems: 'center'
        },
        membershipIcon: {
            marginLeft: 6
        },
        name: {
            fontSize: 16,
            fontWeight: 600,
            lineHeight: '100%'
        },
        infoLine: {
            marginTop: 9
        },
        tags: {
            marginTop: 13
        },
        clickeable: {
            'cursor': 'pointer',
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    })
);

export const PetParent: FunctionComponent<PetParentProps> = props => {
    const classes = useStyles(props);

    const marketplace = useMarketplace();

    const tags = [...props.client.tags.positive, ...props.client.tags.negative];

    const header = (
        <Box>
            <Box className={classes.nameContainer}>
                <Typography
                    className={clsx(classes.name, { [classes.clickeable]: props.onShowClient })}
                    onClick={props.onShowClient}
                >{`${props.client.firstName} ${props.client.lastName}`}</Typography>
                {props.matchMemebrships && <MembershipIcon className={classes.membershipIcon} />}
            </Box>
            <InfoLine
                icon={faPhone}
                className={classes.infoLine}
            >
                {formatPhoneNumber(props.client.phone, marketplace.basics.address.country!.id)}
            </InfoLine>
        </Box>
    );

    return (
        <ExpandableSection
            header={header}
            initExpanded={props.initExpanded ?? true}
            className={props.className}
        >
            {!props.client.temporalEmail && (
                <InfoLine
                    icon={faEnvelope}
                    className={classes.infoLine}
                >
                    {props.client.email}
                </InfoLine>
            )}
            {
                <InfoLine
                    icon={faLocationDot}
                    className={classes.infoLine}
                >
                    {props.client.address !== undefined
                        ? `${props.client.address?.street ?? ''}${
                              props.client.address?.suite ?? '' !== '' ? ' ' + props.client.address?.suite : ''
                          }, ${props.client.address?.city ?? ''}, ${props.client.address?.state ?? ''}`
                        : `Not Defined`}
                </InfoLine>
            }
            {(tags.length > 0 || props.client.blocked) && (
                <Tags
                    blockedClient={props.client.blocked}
                    options={tags}
                    className={classes.tags}
                />
            )}
        </ExpandableSection>
    );
};

export default PetParent;
